/* opt all Mixpanel libraries in or out of tracking using standard library methods:
 *
 *  mixpanel.opt_in_tracking();
 *  mixpanel.opt_out_tracking();
 */
function updateTracking(isOn) {
  const changeOptFunc = isOn ? `opt_in_tracking` : `opt_out_tracking`;
  const checkOptFunc = isOn ? `has_opted_in_tracking` : `has_opted_out_tracking`;
  const libs = [window.mixpanel].concat(
    Object.values(window.mixpanel).filter((val) => val instanceof window.mixpanel.constructor),
  );

  libs.forEach((lib) => {
    if (!lib[checkOptFunc]()) {
      lib[changeOptFunc]();
    }
  });
}

export function deactivateTracking() {
  updateTracking(false);
}

export function activateTracking() {
  updateTracking(true);
}
